module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tud-drawer'), _vm._v(" "), _c('tud-toolbar'), _vm._v(" "), _c('main', {
    staticStyle: {
      "min-height": "90vh"
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color-front": "blue-grey",
      "color-back": "blue-grey lighten-2"
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "child-flex": ""
    }
  }, [_c('router-view', {
    key: _vm.$route.params.id,
    attrs: {
      "keep-alive": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    staticStyle: {
      "padding-bottom": "68px"
    }
  }, [_c('div', {
    staticClass: "elevation-0 pl-2 pr-2",
    staticStyle: {
      "background-color": "transparent",
      "font-size": "0.8em",
      "color": "#aaa",
      "text-shadow": "1px 1px 3px #bbb",
      "text-align": "center"
    }
  }, [_vm._v("\n      Developed by "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://tudconsult.ro/"
    }
  }, [_vm._v("TUD")]), _vm._v(" "), _c('br'), _vm._v("\n      © Verde Smart Data. " + _vm._s(_vm.translate('interfata', 'app-copyright')) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.translate('interfata', 'app-icon-surse')) + "\n    ")])]), _vm._v(" "), _c('tud-snack', {
    staticStyle: {
      "z-index": "12000"
    },
    attrs: {
      "messages": _vm.messages,
      "visible": _vm.visibleMessages
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb2576e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 178
// module chunks = 27